import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { LightMode, DarkMode } from "@mui/icons-material";
import { useTheme } from "../contexts/ThemeContext";
import { AUTH_TOGGLE_ICON_PX, authToggleButtonShellSx } from "./authToggleConstants";

const ThemeToggleButton = ({
  size = "medium",
  position = "fixed",
  embedded = false,
  sx = {},
  showOnlyOnLogin = true,
}) => {
  const { isDarkMode, toggleTheme } = useTheme();

  const isLoggedIn = localStorage.getItem("realmJwt") || localStorage.getItem("supabaseToken");

  if (showOnlyOnLogin && isLoggedIn) {
    return null;
  }

  const defaultSx = {
    ...(embedded || position === "static"
      ? {}
      : {
          position: "fixed",
          top: 16,
          right: 16,
          zIndex: 1000,
        }),
    ...authToggleButtonShellSx(isDarkMode),
    ...sx,
  };

  return (
    <Tooltip title={`Switch to ${isDarkMode ? "light" : "dark"} mode`}>
      <IconButton
        onClick={toggleTheme}
        size={size}
        sx={defaultSx}
        aria-label="toggle theme"
      >
        {isDarkMode ? (
          <LightMode sx={{ fontSize: AUTH_TOGGLE_ICON_PX, color: "warning.main" }} />
        ) : (
          <DarkMode sx={{ fontSize: AUTH_TOGGLE_ICON_PX, color: "primary.main" }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;
